import React, { createContext } from 'react';

export const AudioAppContext = createContext({});
